<template>
  <div>
    <LoadingPlugin
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    />

    <add-destination
      v-if="showModal"
      :show="showModal"
      :onCancel="closeModal"
      :isAddShipment="true"
      @newOrigin="newOrigin"
      :newShipmentOrigin="newShipmentOrigin"
      type="origin"
    />

    <add-destination
      v-if="showDestination"
      :show="showDestination"
      :onCancel="closeDestination"
      :isAddShipment="true"
      @newDestination="newDestination"
      :newShipmentDestination="newShipmentDestination"
      type="destination"
    />

    <form ref="originDestinationForm">
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label for="reference">Origin</label>
              <button
                @click="showModal = true"
                class="custom-button"
                type="button"
              >
                <icon-circle-add class="cursor-pointer" />
                Add Origin
              </button>
            </div>
            <div class="input-group">
              <select
                class="form-control"
                style="height: 50px"
                name="origin"
                v-model="origin"
                required
              >
                <option
                  :value="newShipmentOrigin"
                  v-if="newShipmentOrigin && newShipmentOrigin.name"
                >
                  {{ newShipmentOrigin.name }}
                </option>
                <option
                  v-for="origin in origins"
                  :key="origin.id"
                  :value="origin"
                >
                  {{ origin.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group mb-0">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label for="reference">Destination</label>
              <span @click="showDestination = true" class="cursor-pointer">
                <icon-circle-add class="cursor-pointer" /> Add Destination
              </span>
            </div>
            <div class="w-100">
              <ports-combo-box
                refName="destinationComboBox"
                :data="destinations"
                prefix="destinations"
                :destination="destination"
                @updatePort="updateDestination"
              />
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6">
          <map-direction
            :start="originLatLng"
            :end="destinationLatLng"
            @isLoading="handleLoading"
          />
        </div>
        <div class="report">
          <input
            type="checkbox"
            name="schedule"
            id="schedule"
            v-model="isScheduledReport"
          />
          <label for="schedule"
            >Schedule your shipment report automatically</label
          >
        </div>
      </div>
      <div class="schedule" v-if="isScheduledReport">
        <div class="schedule-input">
          <label>Period</label>
          <select v-model="schedule">
            <option value="" disabled>Select Period</option>
            <option
              v-for="(period, index) in schedulePeriod"
              :key="index"
              :value="period.value"
            >
              {{ period.label }}
            </option>
          </select>
        </div>
        <div class="combo">
          <ComboBox
            :data="getUsers"
            prefix="users"
            :isItemChecked="
              (user) => selectedusers.map(({ id }) => id).includes(user.id)
            "
            @checkClick="(user) => updateUser(user)"
            @doSearch="doSearchUser"
            :isSelectAll="getUsers.length === selectedusers.length"
            :selectAll="
              () =>
                (selectedusers = getUsers.map(({ value, id }) => ({
                  value,
                  id,
                })))
            "
            :deSelectAll="() => (selectedusers = [])"
            :label="$t('add_users_staff_email')"
            :selected="selectedusers"
            :showValues="true"
            @removeItem="removeASelectedUser"
            :errorMessage="''"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";
import MapDirection from "./MapDirection.vue";
import AddDestination from "../../Modals/AddDestination.vue";
import LoadingPlugin from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ComboBox from "../../../components/ComboBox.vue";
import PortsComboBox from "../../../components/PortsComboBox.vue";
export default {
  components: {
    IconCircleAdd,
    MapDirection,
    AddDestination,
    LoadingPlugin,

    ComboBox,
    PortsComboBox,
  },
  name: "OriginDestinationStep",
  props: {
    originProp: {
      type: Object,
      default: () => ({}),
    },
    destinationProp: {
      type: Object,
      default: () => ({}),
    },
    shipmentDetails: {
      type: Object,
      default: () => ({}),
    },
    shipmentType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      origin: {},
      destination: {},
      showModal: false,
      showDestination: false,
      newShipmentOrigin: {},
      newShipmentDestination: {},
      isLoading: false,
      fullPage: true,
      selectedusers: [],
      schedule: "",
      isScheduledReport: false,
    };
  },
  mounted() {
    this.sortedusers = this.users
      //   .filter((user) => !activeusers.includes(user.email))
      .map(({ email, ...rest }) => ({
        name: email,
        email,
        ...rest,
      }));
    // this.sortedDestinations = this.destinations;
  },

  computed: {
    ...mapGetters(["destinations", "origins", "users", "getShipmentType"]),
    originLatLng() {
      if (
        this.origin.address &&
        this.origin.address.lat &&
        this.origin.address.lng
      ) {
        const { lat, lng } = this.origin.address;
        return { lat, lng };
      } else return null;
    },
    getUsers() {
      return this.users.map(({ email, ...rest }) => ({
        name: email,
        value: email,
        ...rest,
      }));
    },
    destinationLatLng() {
      if (
        this.destination.address &&
        this.destination.address.lat &&
        this.destination.address.lng
      ) {
        const { lat, lng } = this.destination.address;
        return { lat, lng };
      } else {
        const { lat, lng } = this.shipmentDetails;
        return lat && lng ? { lat, lng } : null;
      }
    },
    schedulePeriod() {
      const airPeriod = [
        { label: "2 hours after shipment reaches destination", value: 2 },
        { label: "4 hours after shipment reaches destination", value: 4 },
      ];
      const seaPeriod = [
        { label: "24 hours after shipment reaches destination", value: 24 },
        { label: "48 hours after shipment reaches destination", value: 48 },
      ];
      return this.getShipmentType === "air" ? airPeriod : seaPeriod;
    },
  },

  methods: {
    ...mapActions(["searchPorts"]),
    closeModal() {
      this.showModal = false;
    },
    closeDestination() {
      this.showDestination = false;
    },
    removeASelectedUser(id) {
      this.selectedusers = this.selectedusers.filter((item) => item.id !== id);
    },
    updateUser(val) {
      const index = this.selectedusers.findIndex((item) => item.id === val.id);
      if (index !== -1) {
        this.selectedusers.splice(index, 1);
      } else {
        this.selectedusers = [
          ...this.selectedusers,
          { value: val.value, id: val.id },
        ];
      }
    },
    doSearchUser({ target: { value } }) {
      const filtered = this.users
        .filter((user) =>
          user.email.toLowerCase().includes(value.toLowerCase())
        )
        .map(({ email, ...rest }) => ({
          name: email,
          ...rest,
        }));
      this.sortedusers = filtered;
    },
    validateForm() {
      const form = this.$refs.originDestinationForm;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        origin: this.origin,
        destination: this.destination,
        isScheduledReport: this.isScheduledReport,
        schedule:
          this.schedule && this.isScheduledReport ? +this.schedule : undefined,
        notify: this.selectedusers.length > 0 ? this.selectedusers : undefined,
      };
    },
    newOrigin(origin) {
      this.origin = origin;
      this.newShipmentOrigin = origin;
      this.showModal = false;
    },
    newDestination(destination) {
      this.destination = destination;
      this.showDestination = false;
      this.newShipmentDestination = destination;
    },
    handleLoading(isLoading) {
      this.isLoading = isLoading;
    },
    isDestinationChecked(item) {
      return this.destination && this.destination.id === item.id;
    },
    updateDestination(item) {
      this.destination = item;
    },
  },
  watch: {
    originProp: {
      handler(newValues) {
        if (newValues.name) {
          this.origin = this.originProp;
          if (!this.originProp.id) {
            this.newShipmentOrigin = this.originProp;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    destinationProp: {
      handler(newValues) {
        if (newValues.name) {
          this.destination = this.destinationProp;
          if (!this.destinationProp.id) {
            this.newShipmentDestination = this.destinationProp;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button.custom-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #213e7a;
}

button.custom-button:focus {
  outline: none; /* Remove focus outline if not desired */
}
.report {
  padding-inline: 10px;
  padding-bottom: 24px;
  padding-top: 10px;
  border-bottom: 1px solid #0000001a;
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.report label {
  margin: 0px !important;
}
.schedule {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* align-items: center; */
  gap: 20px;
}
.schedule-input {
  display: flex;
  flex-direction: column;
}
.schedule select {
  height: 46px;
}
.combo {
  width: 100%;
}
</style>
